<template>
  <base-dialog-no-button v-if="isLoading" title="Please wait..." @waiting="ClickWaitingDialog">
    <template #default>
      <div class="d-flex justify-content-start align-items-center">
        <img
        class="logo"
        src="@/assets/loader.gif"
        width="100"
      />
      <p class="m-0">{{ waitingMessage }}</p>
      </div>
    </template>
  </base-dialog-no-button>

  <base-dialog v-if="inputInvalid" title="Invalid Selection" @close="ClickDialogClose">
    <template #default>
      <p>{{ errorText }}</p>
    </template>
    <template #actions>
      <base-button @click="ClickDialogClose">OK</base-button>
    </template>
  </base-dialog>

  

  <div v-if="readyToSearch" class="mt-4">
    <SchedulerComponent class="left-container" :events="e" :venueId="venueIds" @search-submit="searchForBooking" :maxCapacity="this.solutions.venueObj.maxCapacity"></SchedulerComponent>
   </div>
  
  <div v-if="isLoaded">
    <ul v-if="slotAvailable">
      <facility-resource v-for="res in availableVenuesInSelectedGroup" :key="res" :id="res.VenueId"
        :venuename="res.VenueName" :address="res.Address" :maxcapacity="res.MaxCapacity"
        :starttime="searchConditionsObject.StartDate" :endtime="searchConditionsObject.VenueEndTime" :venueId="res.VenueId"
        @booking-confirmed="searchForFacilities"></facility-resource>
    </ul>

    <base-card v-if="searchConditionsObject !== null && !slotAvailable">
      <span>Sorry, booking for this venue is full, please pick other time or
        date</span>
    </base-card>
  </div>
</template>

<script>
import SchedulerComponent from '../Calendar.vue'
// import SearchConditions from './SearchConditions';
import FacilityResource from './FacilityResource.vue';

import {
  confirmPaidBookingAPI,
  searchFacilityAPI,
  searchBookingAPI,
  allVenuesAPI,
  weeklyDefinition,
  tokenAPI                                                                                    
} from './../../../../config';

import {
  EventType,
  DefaultEventStatus,
  DefaultEventCoordinator,
  DefaultContactType,
  DefaultEventSource,
  DefaultVenuesList,
} from '../data';



function dateFormJoiner(date) {
  const dateStr = String(date);
  const dateParts = dateStr.split('-');
  //  console.log(date, dateStr);
  const newDateStr = dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0];

  return newDateStr;
}

function dateFormJoin(date) {
  const dateStr = date;
  const date1 = dateStr.split(' ');
  const dateParts = date1[0].split('/');
  const newDateStr = dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0] + ' ' + date1[1];
  return newDateStr;
}

export default {
  components: { FacilityResource, SchedulerComponent },
  emits: ['facilities-loaded'],
  props: ['solutions'],
  inject: [
    'getNewUser',
    'getBookingDetails',
    //  'resources',
    'setConfirmedBookingDetails',
  ],
  data() {
    return {
      e: null,
      events: null,
      waitingMessage:
        'Please wait for a moment while your request is being processed ',
      // resources: this.resources,
      token: '',
      errorText: 'Oops, At least one input is invalid, please try again.',
      inputInvalid: false,
      isLoading: false,
      isLoaded: false,
      readyToSearch: false,
      slotAvailable: false,
      dailyOnly: false,
      allowRecursive: false,
      slots: false,
      now: null,
      startDate: null,
      endDate: null,
      searchConditionsObject: null,

      // priceCatalogue: 'hourly',

      blockedVenue: null,
      venueIds: [],
      allAvailableVenues: [], // assume all is available
      allVenues: [], // assume all is available
      availableVenuesInSelectedGroup: [],
      bookedItems: [],

      searchFieldsObject: [],

      startHour: null,
      endHour: null,
      eventPax: null,
      currentEnv: null,

      priceCatalogue: null,
      eventType: null,

      currentUser: {
        ContactId: null,
        BookingName: '',
        Firstname: '',
        Email: '',
        Organisation: '',
        Phone: '',
        Lastname: '',
        DisplayField: '',
      },
    };
  },
  watch: {
    events() {
      this.e = this.events
    },
    // make cherry pick all what is no needed here, etc, filtering to only all venue ids
    // also filter out what is already booked
    allVenues() {
      this.availableVenuesInSelectedGroup = this.allVenues.filter(
        (venue) => this.venueIds.indexOf(venue.VenueId) > -1
      );
      if (this.bookedItems.length > 0) {
        this.availableVenuesInSelectedGroup =
          this.availableVenuesInSelectedGroup.filter(
            (venue) => this.bookedItems.indexOf(venue.VenueId) < 0
          );
      }
    },

    availableVenuesInSelectedGroup() {
      this.slotAvailable = this.availableVenuesInSelectedGroup.length > 0;
    },

    priceCatalogue() {
      this.eventType = EventType[this.priceCatalogue];
    },
    solutions() {
      this.readyToSearch = false;
      if (this.solutions.token !== null) {
        this.token = this.solutions.token;
        this.currentEnv = this.solutions.env;
        this.priceCatalogue = this.solutions.pc;
      }
      if (this.solutions.venueObj !== null) {
        this.venueIds = this.solutions.venueObj.venueIds;
        this.allowRecursive = this.solutions.venueObj.allowRecursive;
        this.dailyOnly = this.solutions.venueObj.dailyOnly;
        this.allowRecursiveWhitlam = this.solutions.venueObj.allowRecursive;
        this.dailyOnlyWhitlam = this.solutions.venueObj.dailyOnly;
        // console.log(this.dailyOnly);
        if (this.venueIds) {
          this.getAllBookings();
      }
        // console.log(this.readyToSearch)
      }
    },
  },

  mounted() {
    this.startDate = '2022-10-01';
    this.endDate = '2022-12-31';

    // getting all the varialbe from the solutions
    // console.log(this.startDate);
    if (this.solutions.token !== null) {
      this.token = this.solutions.token;
      this.venueIds = this.solutions.venueIds;
      console.log('venueIDs', this.solutions);
    }

    this.$eventBus.on('resetSession', () => {
      this.availableVenuesInSelectedGroup = [];
    });

    // send all data to be save and save the booking
    this.$eventBus.on('paymentApproved', () => {
      //  console.log('send confirm booking payment', payment);
      this.bookingPaidConfirmed();
    });
    //    console.log('the stored resource solutions ', this.solutions);
  },

  methods: {
    // addMessage(message) {
    //   this.messages.unshift(message);
    //   if (this.messages.length > 40) {
    //     console.log(this.messages)
    //     this.messages.pop();
    //   }
    // },

    getPriceCatalogue(searchConditionsObject) {
      let numberOfDays = searchConditionsObject.NumberOfDays;
      // afterhour is a fake hack for make a booking overlapping the afterhour

      // console.log('search object', searchConditionsObject);

      if (searchConditionsObject.AfterHour) {
        return 'afterhour';
      } else if (numberOfDays >= weeklyDefinition && numberOfDays < 28) {
        return 'weekly';
      } else if (numberOfDays >= 28 && numberOfDays < 364) {
        return 'monthly';
      } else if (numberOfDays >= 364) {
        return 'annually';
      } else {
        return 'hourly';
      }
    },

    convertHourMethod(hour) {
      const intH = parseInt(hour);
      if (intH < 10) {
        return '0' + hour + ':00';
      } else {
        return hour + ':00';
      }
    },

    ClickDialogClose() {
      this.inputInvalid = false;
    },

    // TODO, maybe move this to the main and saving this every stage
    // update the eventStatus when confirm
    bookingPaidConfirmed() {
      var endDateFormat = this.searchConditionsObject.EndDate.split(' ')
      var endTime = new Date( new Date(dateFormJoin(this.searchConditionsObject.EndDate)).getTime() + 1000 * 60 ).toLocaleTimeString('en-US', {
            // en-US can be set to 'default' to use user's browser settings
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
      })
      // console.log(endTime);
      const newUser = this.getNewUser();
      var reqBookingDetail = {
        EventName: newUser.bookingName,
        EventPax: this.searchConditionsObject.VenuePax,
        VenueBlockId: [this.blockedVenue.VenueBlockId], // confirm the booking first , this can be multiple booking when use multiple selection
        EventType: this.eventType, //{ Id: this.eventTypeId, Name: this.eventTypeName }, // pass the from the link
        StartDate: this.searchConditionsObject.StartDate,
        EndDate: endDateFormat[0] + ' ' + endTime,
        EventContact: {
          ContactType: DefaultContactType,
          ContactId: newUser.id,
        },
        Contact: {
          Firstname: newUser.firstName,
          Lastname: newUser.lastName,
          Email: newUser.email,
          Organisation: '',
          Phone: newUser.phone,

          DisplayField: '',
        },
        EventStatus: DefaultEventStatus,
        EventCoordinator: DefaultEventCoordinator,
        ContactType: DefaultContactType,
        EventSource: DefaultEventSource,
      };

      var raw = JSON.stringify(reqBookingDetail);

      // console.log('token is here ', raw, this.token);
      var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('Authorization', 'Bearer ' + this.token);
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      // console.log('request header ', myHeaders);
      fetch(
        this.currentEnv.priava + confirmPaidBookingAPI,
        //'https://apac-sandbox-app.priava.com/api/rest/v2/event/save?IgnoreWarnings=true',
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          //        console.log('booking result', result);

          if (result.success) {
            //this.booked = true;
            this.setConfirmedBookingDetails(result, reqBookingDetail);
            //  this.setSelectedTag('payment-page');
            // console.log('request booking success ');
          } else {
            // this.booked = false;
            // this.setSelectedTag('payment-page');
          }
        })
        .catch((error) => console.log('error', error));
    },

    getAllBookings() {
      this.isLoading = true
      this.waitingMessage = "Please calendar is in process..."
      var self = this
      // console.log('heelooo');      
      this.loadCalendar = true   
      var _startDate = dateFormJoiner(self.startDate); //self.startDate.replaceAll('-', '/');
      var _endDate = dateFormJoiner(self.endDate); //self.startDate.replaceAll('-', '/');
      console.log(self.venueIds);
      let so = {};
      so.StartDate = _startDate + ' 08:00';
      so.EndDate = _endDate + ' 19:00';
      so.VenueId = self.venueIds;
      so.OnlyReserved = false;
      so.VenueGroupSearch = false;
      var raw = JSON.stringify(so);
      fetch(self.currentEnv.tokenUrl + tokenAPI)
        .then((response) => {
          return response.text();
        })
        .then((result) => {
            // console.log('my init token ---', result);
          self.token = result;
          // console.log(self.token);
          var myHeaders = new Headers();
          myHeaders.append('Content-Type', 'application/json');
          myHeaders.append('Authorization', 'Bearer ' + self.token);
          var requestOption = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow',
          };
           fetch(self.currentEnv.priava + searchBookingAPI, requestOption)
              .then((response) => response.json())
              .then((data) => {
                if (data.success) {                  
                  console.log(data)
                  self.getSchedules(data);
                }
              })
              .catch((error) => {
                console.log('error', error);
              });

          //TODO
        })
        .catch((error) => {
          console.log('token error the resources ', error);
          this.token = '';
          this.waitingMessage = "Token error, Please check your internet"
              //  console.log('local token ', localToken);
        });
    },


    getSchedules(result) {
      console.log(result)
      var schedule = {};
      var events = [];
      var data = result.result;
        data.forEach( function(item) {
          var lastDate = item.EndDate.split(' ');
          lastDate = lastDate[0].split('/');
          const DateStr = lastDate[2] + '-' + lastDate[1] + '-' + lastDate[0];
          // console.log(DateStr)
          if (new Date(dateFormJoin(item.EndDate)).getMinutes() != 0 && new Date(dateFormJoin(item.EndDate)).getMinutes() != 30) {
            var TheEndTime = new Date( new Date(dateFormJoin(item.EndDate)).getTime() + 1000 * 60 ).toLocaleTimeString('en-US', {
                  // en-US can be set to 'default' to use user's browser settings
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false,
            })
            schedule = {
              start_date: dateFormJoin(item.StartDate),
              end_date: DateStr + ' ' + TheEndTime,
              text: item.VenueName,
            }
          } else {
            schedule = {
              start_date: dateFormJoin(item.StartDate),
              end_date: dateFormJoin(item.EndDate),
              text: item.VenueName,
            }
          }
          
          events.push(schedule);
        });
        this.events = events
        this.readyToSearch = true;
        this.isLoading = false;
    },
    // get the fullList
    // get the booked List

    // exclude the booked List
    // construct the available booking list for display

    // click to confirm.

    async getAllVenues() {
      var raw = JSON.stringify(DefaultVenuesList);
      var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('Authorization', 'Bearer ' + this.token);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      await fetch(
        //'https://apac-sandbox-app.priava.com/api/rest/v2/common/catl/get',
        this.currentEnv.priava + allVenuesAPI,
        requestOptions
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.success) {
            //   console.log(' all', data);
            this.allVenues = data.result.result;
            this.isLoading = false;

            return true;
          }
        })

        // console.log(result, this.venueIds);

        .catch((error) => {
          this.isLoading = false;
          console.log('error', error);
          this.inputInvalid = true;
        });
    },

    searchForBooking(searchObject) {
      // console.log('search object', searchObject);
      this.availableVenuesInSelectedGroup = [];
      this.bookedItems = [];
      this.isLoading = true;
      let so = {};
      so.StartDate = searchObject.StartDate;
      so.EndDate = searchObject.EndDate;
      so.VenueId = this.venueIds;
      so.OnlyReserved = false;
      so.VenueGroupSearch = false;
      this.searchConditionsObject = searchObject;
      this.makeSearchForExistingBookingRequest(so);
    },

    makeSearchForExistingBookingRequest(searchFieldsObject) {
      var raw = JSON.stringify(searchFieldsObject);      
      this.waitingMessage = "Please wait for a moment while your request is being processed "
      var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('Authorization', 'Bearer ' + this.token);
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      fetch(this.currentEnv.priava + searchBookingAPI, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            let items = data.result;
            
            // don't do the search if we know there's no slot available
            //TODO, this will not work if ParentGroupID is used
            items.forEach((item) => {
              if (!this.bookedItems.includes(item.VenueId)) {
                this.bookedItems.push(item.VenueId);
              }
            });

            if (this.bookedItems.length >= this.venueIds.length) {
              this.isLoading = false;
            } else {
              this.getAllVenues();
              this.slots = true;
            }
            this.isLoaded = true;
            //return;
          } else {
            this.inputInvalid = true;
            this.isLoading = false;
            this.errorText = data.error;
          }
          this.isLoaded = true;          
          this.waitingMessage = "Please wait for a moment while your request is being processed "
          //  console.log('venue block id ', data.result[0].VenueBlockId);
        })

        .catch((error) => {
          console.log('error', error);
        });
    },

    searchForFacilities(selectedItem) {
      //TODO, here construct an array based on search get booking first.
      // TODO, once the booking list return, market booked item in red ( use style, need to think about it)
      //

      //    console.log('selected Item', selectedItem, this.searchConditionsObject);

      // this.resources = [];
      this.searchFieldsObject = [];

      if (this.searchConditionsObject == null) {
        this.inputInvalid = true;
        this.errorText = 'This selection is outside of operating hours';
        return;
      } else {
        this.inputInvalid = false;
      }

      this.priceCatalogue = this.getPriceCatalogue(this.searchConditionsObject);

      //  console.log('pricing catelogue', this.priceCatalogue);

      let searchOpt = Object.assign({}, this.searchConditionsObject);
      searchOpt.VenueId = selectedItem.venueid;

      // need venue ID
      /*
      console.log(
        'price catalogue searchConditionObject',
        this.priceCatalogue,
        this.searchConditionsObject,
        searchOpt
      );
      */

      this.searchFieldsObject.push(searchOpt);

      this.isLoading = true;

      this.makeRequestSearchAvailableBookings(this.searchFieldsObject);
    },

    makeRequestSearchAvailableBookings(searchFieldsObject) {
      var raw = JSON.stringify(searchFieldsObject);
      //  console.log('token is here ', raw, '\n mactch?\n', this.token);
      var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('Authorization', 'Bearer ' + this.token);
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      fetch(this.currentEnv.priava + searchFacilityAPI, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          // this.isLoading = false;
          // console.log('property 0', data);
          if (data.success) {
            this.blockedVenue = data.result[0];

            // this can be done by watch
            this.isLoading = false;
            this.getBookingDetails(
              this.blockedVenue,
              this.priceCatalogue,
              //  this.searchConditionsObject
            );
          } else {
            // alert(data.error);
            this.inputInvalid = true;
            this.errorText = data.error;
          }
          // this.resources = results;
          this.isLoaded = true;
          //  console.log('venue block id ', data.result[0].VenueBlockId);
        })

        //.then(result => console.log(result))
        .catch((error) => {
          console.log('error', error);
        });
    },
  },
};
</script>

<style scoped>
html,
  body {
    height: 100%;
    margin: 0;
    padding: 0;
  }
  
  .container {
    height: 100%;
    width: 100%;
  }
  
  .left-container {
    overflow: hidden;
    position: relative;
    height: 85vh;
    display: inline-block;
    width: 100%;
  }
  
  .right-container {
    border-right: 1px solid #cecece;
    float: right;
    height: 100%;
    width: 19%;
    box-shadow: 0 0 5px 2px #aaa;
    position: relative;
    z-index: 2;
  }
  
  .scheduler-messages {
    list-style-type: none;
    height: 50%;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding-left: 5px;
  }
  
  .scheduler-messages > .scheduler-message {
    background-color: #f4f4f4;
    box-shadow: inset 5px 0 #d69000;
    font-family: Geneva, Arial, Helvetica, sans-serif;
    font-size: 14px;
    margin: 5px 0;
    padding: 8px 0 8px 10px;
  }
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  margin: auto;
  max-width: 50rem;
}

p.searchWait {
  right: -50px;
  position: relative;
  word-wrap: break-word;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-active {
  opacity: 0;
}

@media (max-width: 768px) {
  .search-panel {
    margin: 1rem auto;
  }
}
</style>
